import React from 'react';
import ServiceTemplate from '@/components/ServiceTemplate';

const RenovationComplete = () => {
  return (
    <ServiceTemplate
      title="Rénovation Complète"
      heroImage="https://images.unsplash.com/photo-1558211583-03ed8a0b3d5f?w=1600"
      description="Transformation totale de votre salle de bains, de la démolition à la finition."
      priceRange="18’000 - 35’000 CHF"
      duration="3-5 semaines"
      features={[
        'Démolition complète de l\'ancienne salle de bains',
        'Refonte totale de la plomberie et électricité',
        'Installation d\'un nouveau carrelage mural et au sol',
        'Pose de sanitaires haut de gamme (douche, lavabo, WC)',
        'Installation de meubles et rangements sur mesure',
        'Finitions impeccables et garantie travaux'
      ]}
      includes={[
        {
          title: 'Démolition',
          description: 'Évacuation complète des anciens équipements et revêtements'
        },
        {
          title: 'Plomberie',
          description: 'Refonte complète du réseau d\'eau et d\'évacuation'
        },
        {
          title: 'Électricité',
          description: 'Mise aux normes et installation de nouveaux points lumineux'
        },
        {
          title: 'Carrelage',
          description: 'Pose de carrelage mural et au sol avec étanchéité optimale'
        },
        {
          title: 'Sanitaires',
          description: 'Installation de douche, baignoire, lavabo et WC'
        },
        {
          title: 'Finitions',
          description: 'Peinture, joints, meubles et accessoires'
        }
      ]}
      benefits={[
        'Transformation complète avec un rendu neuf et moderne',
        'Amélioration de la fonctionnalité et de l\'esthétique',
        'Augmentation de la valeur de votre bien immobilier',
        'Matériaux et équipements de qualité supérieure',
        'Chantier propre et respect des délais',
        'Garantie sur les travaux et les matériaux'
      ]}
    />
  );
};

export default RenovationComplete;